import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ApiConnectionService } from 'src/app/services/core/api-connection.service';

@Component({
  selector: 'app-modal-name',
  templateUrl: './modal-name.component.html',
  styleUrls: ['./modal-name.component.scss']
})
export class ModalNameComponent implements OnInit {
  @Input() public portfolioIds: string[] = [];
  loading = true;
  retrievingPDF = false;
  fetchedPDF = false;
  portfolioPDFUrl:SafeResourceUrl = '';
  showButtons:boolean = false;

  constructor(
    public activeModal: NgbActiveModal, 
    public sanitizer: DomSanitizer,
    public apiConnection: ApiConnectionService
  )
  { }

  ngOnInit(): void {
    this.loading = false
    this.portfolioPDFUrl = this.sanitizer.bypassSecurityTrustResourceUrl('https://api.methodem.dev/users/portfolioPdf/&base64=1');
  }
  
  async submit(download = false) {
    if (this.retrievingPDF) {
      return
    }

    this.loading = true;

    this.retrievingPDF = true;
    const form:HTMLFormElement = document.querySelector('#NameInputForm');
    const formData = new FormData(form);

    const response = await this.apiConnection.post('users/portfolioPdf/&base64=1',formData);
    const result = await response.text();

    this.loading = false;

    const byteCharacters = atob(result);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf'});
    const blobURL = URL.createObjectURL(blob);

    if (download === true) {
      let name = formData.get('name');
          name = this.cleanString(name);
      const date = new Date();
    
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); 
      const year = date.getFullYear();
  
      const dateString = `${day}-${month}-${year}`;

      const link = document.createElement('a');
      link.href = blobURL;
      link.download = 'portfolio-' + name + '-' + dateString + '.pdf';
      document.body.appendChild(link);
      
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobURL);
      return;
    }

    const pdfIframe:HTMLIFrameElement = document.querySelector('#portfolioPDF');
    pdfIframe.src = blobURL;
    
    this.fetchedPDF = true;
    this.retrievingPDF = false;
    this.showButtons = true;
  }
  
  cleanString(title) {
      return title
          .toLowerCase()                   
          .trim()                          
          .replace(/[^\w\s-]/g, '')       
          .replace(/\s+/g, '-')          
          .replace(/-+/g, '-');   
  }

  downloadPDF() {
    this.submit(true);
  }

  printPDF() {
    let printIFrame:HTMLIFrameElement = document.querySelector('#portfolioPDF');
    
    if (printIFrame instanceof HTMLIFrameElement) {
      printIFrame.contentWindow.focus();
      printIFrame.contentWindow.print();
    }
  }

  close() {
    this.activeModal.close(false);
  }
}
